import { computed } from 'vue';
import router from '@/router';

const urlHasSearchParam = (url: string, searchParamName: string): boolean => {
  const queryStart = url.indexOf('?');
  if (queryStart === -1) {
    return false;
  }
  return new URLSearchParams(url.slice(queryStart + 1)).has(searchParamName);
};

export const useModalVisibility = <T>(searchParamName: string) =>
  computed<T | false>({
    get: () => {
      return router.currentRoute.value.query[searchParamName] as T;
    },
    set: (value) => {
      if (value !== false) {
        router.push({
          path: router.currentRoute.value.path,
          query: {
            ...router.currentRoute.value.query,
            [searchParamName]: value as string,
          },
        });
      } else {
        if (!(searchParamName in router.currentRoute.value.query)) {
          return; // avoid endless loops
        }
        const previousUrl = router.options.history.state.back;
        const currentPath = router.currentRoute.value.path;
        if (
          typeof previousUrl === 'string' &&
          previousUrl.startsWith(currentPath) &&
          !urlHasSearchParam(previousUrl, searchParamName)
        ) {
          router.back();
        } else {
          const currentSearchParams = { ...router.currentRoute.value.query };
          delete currentSearchParams[searchParamName];
          router.push({
            path: router.currentRoute.value.path,
            query: currentSearchParams,
            replace: true,
          });
        }
      }
    },
  });
